import { Box, Paper, Table, TableBody, TableCell, TableHead, Typography } from '@material-ui/core';
import moment from 'moment';
import React, { useMemo } from 'react';
import { useCoinUnitPrices } from '../../../hooks/queries/useCoinUnitPrice';
import { CoinUnitPriceType } from '../../../services/api/CoinUnitPrice';
import CoinUnitPriceTable from './CoinUnitPriceTable';
import useStyles from './styles';

const CoinUnitPriceInProgressView = (): JSX.Element => {
  const classes = useStyles();
  const { data: coinUnitPricesFromQuery = [] } = useCoinUnitPrices(CoinUnitPriceType.InProgress);
  const { data: finalizedCoinUnitPricesFromQuery = [] } = useCoinUnitPrices(CoinUnitPriceType.Recent);

  const coinUnitPrice = coinUnitPricesFromQuery[0];

  const coinUnitPricesPastThreeMonths = useMemo(() => {
    return finalizedCoinUnitPricesFromQuery.map(c => [c.month, c.unitPrice]);
  }, [finalizedCoinUnitPricesFromQuery]);

  const estimatedPricesFormula = coinUnitPricesPastThreeMonths.map(([_, price]) => price).join('+');
  const estimatedPricesSum = (
    coinUnitPricesPastThreeMonths.map(([_, price]) => price).reduce((acc, cur) => acc + cur, 0) / coinUnitPricesPastThreeMonths.length
  ).toLocaleString('en-US', {
    maximumFractionDigits: 5,
  });

  return (
    <Box>
      {coinUnitPrice && (
        <Box>
          <Box display="flex" alignItems="center" marginBottom="12px">
            <Typography className={classes.titleYear}>{moment(coinUnitPrice.month, 'YYYYMM').format('MMM YYYY')}</Typography>
            <Typography variant="subtitle1">Coin Unit Price Estimate</Typography>
          </Box>
          <Paper>
            <CoinUnitPriceTable type={CoinUnitPriceType.InProgress} coinUnitPrices={[coinUnitPrice]} />
            <Box padding="25px">
              <Typography>Coin unit price of the past 3 months</Typography>
              <Table className={classes.recentPriceTable}>
                <TableHead style={{ verticalAlign: 'middle' }}>
                  {coinUnitPricesPastThreeMonths.map(([month]) => (
                    <TableCell align="center" padding="none" className={classes.recentPriceTableHead} key={month}>
                      {moment(month, 'YYYYMM').format('MMM YYYY')}
                    </TableCell>
                  ))}
                </TableHead>
                <TableBody>
                  {coinUnitPricesPastThreeMonths.map(([month, price]) => (
                    <TableCell align="center" key={month}>
                      {price}
                    </TableCell>
                  ))}
                </TableBody>
              </Table>
              <Typography style={{ paddingBottom: '9px' }}>Estimated Coin Unit Price</Typography>
              <Typography variant="body2">
                {`(${estimatedPricesFormula}) / ${coinUnitPricesPastThreeMonths.length} = `}
                <span style={{ fontWeight: 'bold' }}>{`$${estimatedPricesSum}*`}</span>
              </Typography>
            </Box>
          </Paper>
        </Box>
      )}
    </Box>
  );
};

export default CoinUnitPriceInProgressView;
